// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightMiniReport-cls1_FFe","cls2":"CiterightMiniReport-cls2_bbW CiterightMiniReport-cls1_FFe"};